var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgClone = function SvgClone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.678 3.01H5.87a1.64 1.64 0 00-1.634 1.634v11.443H5.87V4.644h9.808V3.01zm-.817 3.269H9.139c-.899 0-1.626.735-1.626 1.634l-.008 11.443c0 .899.727 1.634 1.626 1.634h8.999c.899 0 1.634-.735 1.634-1.634v-8.173l-4.903-4.904zM9.139 19.356V7.913h4.904V12h4.087v7.356H9.14z",
    fill: "#9CA6AD"
  })));
};

export default SvgClone;